/*
 * @Author: 丨小小风离丨
 * @Date: 2023-12-11 16:08:02
 * @LastEditTime: 2024-02-26 20:23:19
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-enroll\src\store\reducers\baseInfo.ts
 * @Description: 
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface DataState {
  defaultData: any
  topHeight: number
  mainBackColor: string
  yearsList: any[]
}

const initialState: DataState = {
  defaultData: 0,
  topHeight: 128,
  mainBackColor: '#ffffff',
  yearsList: []
};

export const getConfigAsync = createAsyncThunk(
  'baseInfo/getConfig',
  async () => {
    return new Promise((resolve: any) => {
      setTimeout(() => {
        const response = { /* 模拟的响应数据 */ };
        localStorage.setItem(`${process.env.REACT_APP_SYSTERM_ID}_config`, JSON.stringify(response || ''));
        resolve(10);
      }, 2000); // 模拟2秒延迟
    });
  }
);

const dataSlice = createSlice({
  name: 'baseInfo',
  initialState,
  reducers: {
    setDefaultData: (state, action) => {
      state.defaultData = action.payload;
    },
    setTopHeight: (state: DataState, action) => {
      state.topHeight = action.payload;
    },
    setMainBackColor: (state: DataState, action) => {
      state.mainBackColor = action.payload;
    },
    setYearsList: (state: DataState, action) => {
      state.yearsList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConfigAsync.pending, (state) => {
        // 处理 pending 状态
      })
      .addCase(getConfigAsync.fulfilled, (state, action) => {
        state.defaultData = action.payload;
      })
      .addCase(getConfigAsync.rejected, (state, action) => {
        // 处理 rejected 状态
      });
  }
});

export const {
  setDefaultData,
  setTopHeight,
  setMainBackColor,
  setYearsList
} = dataSlice.actions;

export const selectDefaultData = (state: any) => state?.baseInfo?.defaultData;
export const selectTopHeight = (state: any) => state?.baseInfo?.topHeight;
export const selectMainBackColor = (state: any) => state?.baseInfo?.mainBackColor;
export const selectYearsList = (state: any) => state?.baseInfo?.yearsList;

export default dataSlice.reducer;
